export const markerPositivityColumnPrefix = 'marker.pos.';
